import React from 'react'
import { Divider, } from 'antd';
import { paletteGroupHeadingStyle, paletteGroupLineColor } from '../../shared/ui/paletteTile';

// `subtle` : sous-titres de groupe à l'intérieur d'une section (ex. "Mise en
// page" sous "Eléments disponibles") — plus petits que les titres de section
// pour ne pas rivaliser avec eux visuellement, mais écrits comme les titres du
// panel de droite (cf. shared/ui/panelHeading).
// `accent` : couleur du groupe (cf. FAMILY_ACCENTS), gris sans elle.
// `style` : ajustements de placement propres à l'appelant.
const GenerateDivider = ({ text, color = 'white', fullRow = false, subtle = false, accent, style }) => {
  const subtleStyle = {
    ...paletteGroupHeadingStyle(accent),
    borderColor: paletteGroupLineColor(accent),
  }

  return (
    <Divider
      style={{
        borderColor: color,
        color,
        width: fullRow ? '100%' : '212px',
        minWidth: fullRow ? 0 : undefined,
        gridColumn: fullRow ? '1 / -1' : undefined,
        fontFamily: 'Montserrat',
        fontSize: '11px',
        paddingLeft: '5px',
        paddingRight: '5px',
        marginTop: subtle ? 2 : 8,
        marginBottom: subtle ? 2 : 8,
        ...(subtle ? subtleStyle : {}),
        ...style,
      }}
      plain
    >
      {text}
    </Divider>
  );
};

export default GenerateDivider
